module.exports = __webpack_public_path__ + "img/motiv-logo.93f9b492.svg";